module.exports = __webpack_public_path__ + "img/messages.eb096ca9.svg";